import { TRANSACTION_ATTACHMENT_RESPONSE } from "../action.js";

export const setTransactionAttachmentResponse = (attachmentResponse) => {
    return (dispatch) => {
        dispatch({ type: TRANSACTION_ATTACHMENT_RESPONSE, payload: attachmentResponse });
    };
};